module.exports = __webpack_public_path__ + "static/media/Data_Inteligencia_Competitiva.a1e8a3ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/Data_Inteligencia_Competitiva.png
// module id = 240
// module chunks = 0